import { render, staticRenderFns } from "./edit_technique.vue?vue&type=template&id=c0ac68d8&"
import script from "./edit_technique.vue?vue&type=script&lang=js&"
export * from "./edit_technique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports